// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__5jEYZ","card":"Cards_card__30a-x","infected":"Cards_infected__15bea","recovered":"Cards_recovered__anevF","deaths":"Cards_deaths__3KYin"};